import { VoiceAssistantProvider } from '../../assistant/types/assistant.types';

export enum BackgroundBlur {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum BackgroundBlurMode {
  REGULAR = 'regular',
  LOW_QUALITY_SEGMENTATION = 'low quality segmentation',
}

export enum Layout {
  GRID = 'grid',
  SIDEBAR = 'sidebar',
}

export enum Language {
  ARABIC = 'ar',
  CZECH = 'cs',
  GERMAN = 'de',
  ENGLISH = 'en',
  SPANISH = 'es',
  FRENCH = 'fr',
  HINDI = 'hi',
  HUNGARIAN = 'hu',
  ITALIAN = 'it',
  JAPANESE = 'ja',
  KOREAN = 'ko',
  DUTCH = 'nl',
  POLISH = 'pl',
  PORTUGUESE = 'pt',
  RUSSIAN = 'ru',
  TURKISH = 'tr',
  CHINESE = 'zh',
}

export const LANGUAGE_NAMES: Record<Language, string> = {
  [Language.ARABIC]: 'العربية',
  [Language.CZECH]: 'Čeština',
  [Language.GERMAN]: 'Deutsch',
  [Language.ENGLISH]: 'English',
  [Language.SPANISH]: 'Español',
  [Language.FRENCH]: 'Français',
  [Language.HINDI]: 'हिन्दी',
  [Language.HUNGARIAN]: 'Magyar',
  [Language.ITALIAN]: 'Italiano',
  [Language.JAPANESE]: '日本語',
  [Language.KOREAN]: '한국어',
  [Language.DUTCH]: 'Nederlands',
  [Language.POLISH]: 'Polski',
  [Language.PORTUGUESE]: 'Português',
  [Language.RUSSIAN]: 'Русский',
  [Language.TURKISH]: 'Türkçe',
  [Language.CHINESE]: '中文',
};

export const SUPPORTED_LANGUAGES = [
  // Language.ARABIC,
  Language.CZECH,
  Language.GERMAN,
  Language.ENGLISH,
  Language.SPANISH,
  Language.FRENCH,
  Language.HINDI,
  Language.HUNGARIAN,
  Language.ITALIAN,
  Language.JAPANESE,
  Language.KOREAN,
  Language.DUTCH,
  Language.POLISH,
  Language.PORTUGUESE,
  Language.RUSSIAN,
  Language.TURKISH,
  Language.CHINESE,
];

export type UserSettings = {
  voiceAssistantProvider?: VoiceAssistantProvider;
  layout?: Layout;
  language?: Language;

  newsletterSubscription?: boolean;
  promotionsSubscription?: boolean;
};
